import { render } from "./FooterCopyright.vue?vue&type=template&id=76cb51ee&scoped=true"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import "./FooterCopyright.vue?vue&type=style&index=0&id=76cb51ee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cb51ee"]])

export default __exports__